"use client"
import { Poppins } from "next/font/google";
import PortesClesSlides from "./PortesClesSlides";


const poppins=Poppins({
  subsets: ['latin'],
  weight: ["400", "500", "600", "700", "800", "900"],
})

const ClesSelection = ({ClesProduct}) => {
  return (
    <div className={poppins.className}>

    <div className="relative bg-[url('/bg/portesClés.png')] bg-cover h-[170px] lg:h-[768px] w-full">
      <h1 className="absolute text-center top-1 lg:top-20 right-[32px] lg:right-14 2xl:top-32 2xl:right-44 text-[20px] lg:text-[75px] leading-tight text-[#FFFFFF] uppercase font-bold ">
        Notre selection
        <br />
        de portes <br />
        clés
        <br />
      </h1>
      <PortesClesSlides
        from={0}
        to={ClesProduct.length-1}
        ClesProduct={ClesProduct}
      />
      <button className="absolute bottom-7 lg:bottom-14 right-16 lg:left-[50%] 2xl:left-[40%] w-[71px] h-[13.5px] lg:w-[188px] lg:h-[43px] bg-[#3F3F3F] lg:bg-[#CC0001] text-[9px] lg:text-[29px] font-normal text-[#FFFFFF] rounded-[8px]">Voir Détails </button>
    </div>

    </div>

  );
};

export default ClesSelection;
